import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { userAvatar } from 'cms/utils';
import { loadCourseParticipants } from 'cms/utils/Network';

export default function SelectCourseParticipantModalController( course,props) {

  const [courseParticipants, setCourseParticipants] = useState(false);
  const [count, setGalleryCount] = useState(false);
  const [pages, setPages] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [page, setPage] = useState(1);
  const inputFileRef = useRef(null);

  useEffect(() => {
    if (props.isOpen) {
      setModalIsOpen(props.isOpen);
    }
  }, [props.isOpen]);

  const { isLoading, data ,refetch } = useQuery(['courseParticipants', course , page], () =>
    loadCourseParticipants(course, page, 30),
    {
      onSuccess: (data) => {
        _createPagesArray(data)
        _setCourseParticipants(data)
      },
    }
  );

  const _setCourseParticipants = (data) =>{
    let results;
    if (data.results) {
      if (props.excludeIds) {
        results = data.results.filter((item) => !props.excludeIds.includes(item.id));
        setCourseParticipants(results);
      } else if (props.exlclude_usertalents) {
        results = data.results.filter((item) => !props.exlclude_usertalents.includes(item.usertalent.id));
        setCourseParticipants(results);
      } else {
        setCourseParticipants(data.results);
      }
    }
  }

  const _createPagesArray = (data)=>{
    if (data && data.count) {
      const page_count = data.count % 30 === 0 ? parseInt(data.count / 30) : parseInt(data.count / 30) + 1;
      const pages_array = range(1, page_count);
      setPages(pages_array);
    }
  }

  // const getData = (page) => {
  //   setLoading(true);
  //   loadCourseParticipants(course, page, 30).then((data) => {

  //     if (data && data.count) {
  //       setGalleryCount(data.count);
  //       var page_count = data.count % 30 === 0 ? parseInt(data.count / 30) : parseInt(data.count / 30) + 1;
  //       var pages_array = range(1, page_count);
  //       setPages(pages_array);
  //     }
  //     var results;
  //     if (data.results) {
  //       if (props.excludeIds) {
  //         results = data.results.filter((item) => !props.excludeIds.includes(item.id));
  //         setCourseParticipants(results);
  //       } else if (props.exlclude_usertalents) {
  //         results = data.results.filter((item) => !props.exlclude_usertalents.includes(item.usertalent.id));
  //         setCourseParticipants(results);
  //       } else setCourseParticipants(data.results);
  //     }
  //     setLoading(false);
  //   });
  // };

  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const closeModal = () => {
    setModalIsOpen(false);
    props.onClose();
  };

  const loadPage = async (e, page) => {
    e.preventDefault();
    setPage(page)
    await refetch();
  };

  const setSelectedItem = (item) => {
    if (props.setSelectedItem) props.setSelectedItem(item);
    setModalIsOpen(false);
  };

  return {
    modalIsOpen,
    closeModal,
    isLoading,
    pages,
    page,
    loadPage,
    setSelectedItem,
    courseParticipants,
    userAvatar,
  };;
}
